import React, { useState } from "react";
import { api } from "../../lib/api";
import { FieldIn, FieldArea, Modal } from "./Fields";
import { toast } from "sonner";

export default function SubmitToClientModal({ application, onClose, onSaved }) {
  const [f, setF] = useState({ client_name: application.company_name || "", submitted_at: new Date().toISOString().slice(0, 10), remarks: "" });
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      await api.post("/client-submissions", { application_id: application.id, ...f,
        submitted_at: new Date(f.submitted_at).toISOString() });
      toast.success(`${application.candidate_name} submitted to ${f.client_name}`);
      onSaved();
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); } finally { setSaving(false); }
  };

  return (
    <Modal title="Submit Candidate to Client" onClose={onClose} testid="submit-client-modal">
      <div className="space-y-4">
        <div className="rounded-xl bg-slate-50 p-4 text-sm">
          <div className="font-medium text-[#0F2A4A]">{application.candidate_name}</div>
          <div className="text-xs text-slate-500">{application.job_title}</div>
        </div>
        <FieldIn label="Client Name" val={f.client_name} onChange={v => setF({ ...f, client_name: v })} tid="sc-client" />
        <FieldIn label="Submission Date" type="date" val={f.submitted_at} onChange={v => setF({ ...f, submitted_at: v })} tid="sc-date" />
        <FieldArea label="Remarks (private)" val={f.remarks} onChange={v => setF({ ...f, remarks: v })} tid="sc-remarks" />
        <div className="flex gap-2">
          <button onClick={onClose} className="ae-btn-outline text-sm flex-1">Cancel</button>
          <button onClick={save} disabled={saving || !f.client_name} className="ae-btn-primary text-sm flex-1" data-testid="sc-submit">
            {saving ? "Submitting…" : "Record Submission"}
          </button>
        </div>
      </div>
    </Modal>
  );
}
